import PubSub from "underpub-js";

var BannersContainer = function(options) {

	this.options = {
		$el: false,
		baseClass: 'layout-BannersContainer',
	};

	$.extend(true, this.options, options);

};

BannersContainer.prototype.init = function() {

	var self = this;

};

export default BannersContainer;
